import React from 'react';
import type { ITextElement, Token } from '@basis-theory/react-elements';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

import { BasisTheoryTextElement } from './SharedUI';

type BusinessViewProps = {
  token: Token;
  updateToken: (id: string, ref: React.RefObject<ITextElement>) => void;
  isDarkMode: boolean;
  onNext?: () => void;
};

export const BusinessView = ({
  token,
  updateToken,
  isDarkMode,
  onNext,
}: BusinessViewProps) => (
  <div className="flex flex-col h-fit gap-y-f2">
    <BasisTheoryTextElement
      id="businessLegalName"
      label="Business Legal Name"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessDba"
      label="DBA Name (if applicable)"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessPhone"
      label="Business Phone Number"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessAddress"
      label="Principal Place of Business"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessNaics"
      label="Type of Business (NAICS)"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessWebsite"
      label="Website"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    {onNext != null && <PrimaryButtonV2 onClick={onNext}>Next</PrimaryButtonV2>}
  </div>
);
